import { Add as AddIcon } from '@mui/icons-material';
import type { ComponentProps, FunctionComponent, MouseEventHandler } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { SecondaryActionButton } from '../../../../../design/components/button/SecondaryAction';

type ActionButtonProps = Pick<ComponentProps<typeof SecondaryActionButton>, 'aria-label'> & {
    readonly onClick: MouseEventHandler;
};

export const AddButton: FunctionComponent<ActionButtonProps> = (props) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <SecondaryActionButton
            aria-label={props['aria-label']}
            label={translate('common.add')}
            startIcon={<AddIcon />}
            onClick={props.onClick}
        />
    );
};
